import React, { useState, FunctionComponent } from 'react';

import { BoardResponseObject } from '@api/v4/boards/boardsTypes';

import { ViewRouterContext } from '../view_router';

import AssetBoardCard from '../components/asset_board_card';
import AssetBoardCardThumbnailArea from '../components/asset_board_card_thumbnail_area';
import AssetBoardActionsOverlay from '../components/asset_board_actions_overlay';
import AssetBoardActions from '../components/asset_board_actions';
import AssetBoardCardDescription from '../components/asset_board_card_description';

import RenameBoardModal from './rename_board_modal';
import DeleteBoardModal from './delete_board_modal';

// This spawns a network request for each board, and also uses findValidThumbnail to iterate over at least 1 asset of each board
// We can avoid this if we can find a way to return the thumbnail and asset_count in the initial getAllBoards request
interface BoardCardProps {
  board: BoardResponseObject;
}

const BoardCard: FunctionComponent<BoardCardProps> = ({ board }) => {
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [closeDropdown, setCloseDropdown] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  // we could drill this prop down 2 levels from view_router instead,
  // would make this component more re-usable
  const ViewRouterState = React.useContext(ViewRouterContext);

  const assetCopy = board.attributes.asset_count !== 1 ? t('assets') : t('asset');
  const handleShowRenameModal = (): void => {
    setShowRenameModal(true);
    setCloseDropdown(true);
  };
  const handleShowDeleteModal = (): void => {
    setShowDeleteModal(true);
    setCloseDropdown(true);
  };

  return (
    <>
      {showRenameModal && (
        <RenameBoardModal
          boardName={board.attributes.name}
          boardId={board.id}
          closeModal={(): void => setShowRenameModal(false)}
        />
      )}
      {showDeleteModal && (
        <DeleteBoardModal
          boardName={board.attributes.name}
          boardId={board.id}
          closeModal={(): void => setShowDeleteModal(false)}
        />
      )}
      <AssetBoardCard className="asset-board-board-card">
        <AssetBoardCardThumbnailArea setShowOverlay={setShowOverlay} resource={board}>
          <AssetBoardActionsOverlay showOverlay={showOverlay} buttonText={t("View Board")} onClickHandler={(): void => ViewRouterState.setBoardToView({ boardName: board.attributes.name, boardId: board.id })}>
            <AssetBoardActions
              closeDropdown={closeDropdown}
              handleShowRemoveModal={handleShowDeleteModal}
              handleShowRenameModal={handleShowRenameModal}
              isBoardCard
              updateCloseDropdown={(): void => setCloseDropdown(false)}
            />
          </AssetBoardActionsOverlay>
        </AssetBoardCardThumbnailArea>
        <AssetBoardCardDescription leftText={board.attributes.name} rightText={`${board.attributes.asset_count} ${assetCopy}`} pillStyling="" />
      </AssetBoardCard>
    </>
  );
};

export default BoardCard;
